import React from 'react'
import styles from '../Proj1Folder/Proj1.module.css'
import go1 from '../../Images/go10.jpeg'
import go2 from '../../Images/go9.jpeg'
import go3 from '../../Images/go8.jpeg'
import go4 from '../../Images/go7.jpeg'
import go5 from '../../Images/go6.jpeg'
import go6 from '../../Images/go5.jpeg'
import go7 from '../../Images/go4.jpeg'
import go8 from '../../Images/go3.jpeg'
import go9 from '../../Images/go2.jpeg'
import go10 from '../../Images/go1.jpeg'






export default function Gomplast() {
  return (

    <>
        <div className="container my-5 py-5">
          <div className="row  align-items-center">
            <div className="col-md-6">
                <h3 className={`${styles.color} my-3`}> Gomplast Factory  ​</h3>
                <p> Area:  1000 m2</p>
                <p>Type of works : Architectural , civil  </p>
            </div>
            <div className="col-md-6">
                <img src={go2} alt="achegy" className='img-fluid'/>
            </div>   
          </div>
          <div className="row my-5 pb-5">

                <div className="col-md-4 my-1 text-center">
                  <img src={go1} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
                 <div className="col-md-4 my-1 text-center">
                  <img src={go3} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
                 <div className="col-md-4 my-1 text-center">
                  <img src={go4} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
                 <div className="col-md-4 my-1 text-center">
                  <img src={go5} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
                 <div className="col-md-4 my-1 text-center">
                  <img src={go6} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
                 <div className="col-md-4 my-1 text-center">
                  <img src={go7} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
                 <div className="col-md-4 my-1 text-center">
                  <img src={go8} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
                 <div className="col-md-4 my-1 text-center">
                  <img src={go9} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
                 <div className="col-md-4 my-1 text-center">
                  <img src={go10} alt="achegy" className={`${styles.imgSizeProj}`}/> 
               </div>
               
        
            
      </div>
     
        </div>

    </>
  )
}
